<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column -h-center-">
      <div class="-header">
        <div v-if="'AM'=== userInfo.auth">
          <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_servicerequest.header') }}</p>

        </div>
        <div v-else>
          <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_servicerequest.header.AM') }}</p>
        </div>


      </div>
      <div class="-wrapper -px-5 -py-2" id="dashboard-service-request-status">
        <p :class="`-font-size-12 ${i != 1? '-ml-4': ''}`" v-for="(status,i) in serviceRequestStatusCombo" :key="status.value" v-show="status.value != 'all'" >
          {{ $t(`pages_servicerequest.division.${status.value}`) }}
          <span :class="`-badge ${status.style} -ml-1`">{{!!serviceRequestStatus.status? serviceRequestStatus.status[status.value] || 0 : 0}}</span>
        </p>
      </div>

      <div class="-width-100 -folding-table-wrapper">
        <table class="-table no-border-top -width-100" style="table-layout: fixed" id="dashboard-service-request-table">
          <caption/>
          <colgroup>
            <col style="width: 160px;" />
            <col />
            <col style="width: 120px;" />
          </colgroup>
          <thead>
            <tr >
              <th scope="col">
                <div class="-wrapper-v-center">
                  <span>
                    {{ $t('pages_dashboard_servicerequest.receiveDate') }}
                  </span>
                </div>
              </th>
              <th scope="col">
                <div class="-wrapper-v-center">
                  <span>
                    {{ $t('pages_dashboard_servicerequest.subject') }}
                  </span>
                </div>
              </th>
              <th scope="col">
                <div class="-wrapper-v-center">
                  <span>
                    {{ $t('pages_dashboard_servicerequest.division') }}

                  </span>
                </div>
              </th>
            </tr>
          </thead>

          <tbody v-if="!!serviceRequestStatus.serviceRequests && serviceRequestStatus.serviceRequests.filter(sr => !!sr.id).length > 0" >
            <tr :class="!!serviceRequest.id?'-button-ui': ''"
                @click="goServiceRequest(serviceRequest.id)"
                v-for="serviceRequest in serviceRequestStatus.serviceRequests.filter(sr => !!sr.id)"
                :key="serviceRequest.id"
                :id="'dashboard-service-request-click-'+serviceRequest.id">
              <td :style="!!serviceRequest.id? 'border-style:solid': 'border-style:none'" >{{ serviceRequest.receiveDate }}</td>
              <td :style="!!serviceRequest.id? 'border-style:solid': 'border-style:none'"><div style="line-height: 1.25" class="-ellipsis">{{ serviceRequest.subject }}</div></td>
              <td :style="!!serviceRequest.id? 'border-style:solid': 'border-style:none'">
                <p v-if="serviceRequest.division" :class="!!serviceRequestStatusCombo.find(s => s.value == serviceRequest.division)? serviceRequestStatusCombo.find(s => s.value == serviceRequest.division).cellStyle : ''">{{ $t('pages_servicerequest.division.'+ serviceRequest.division) }}</p>
              </td>
            </tr>
          </tbody>
          <tbody v-else >
            <tr style="height:160px"><td colspan="3" style="text-align:center" ><p class="-color-gray-1 -font-size-12">{{$t('common.no_result')}}</p></td></tr>
          </tbody>

        </table>
      </div>
      <div class="-wrapper end- -width-100 -px-2 -py-2" style="min-height: 40px;">
        <button id="dashboard-service-request-more-button" class="-btn borderless- small- -mr-0" v-if="serviceRequestStatus.hasMore" @click="moreServiceRequest" >
          <span>{{ $t('pages_dashboard_notice.show_all_button') }}</span>
          <span class="material-icons -font-size-12">navigate_next</span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP} from "@/constants/constants";
import moment from "moment";

export default {
  name: 'servicerequest-status',
  componentName: 'ServiceRequestStatus',
  computed: {
    ...mapGetters('dashboard', ['customerList', 'serviceRequestStatus']),
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('servicerequest', ['serviceRequestStatusCombo'])
  },
  data () {
    return {
      divisionStyle: {
        'open': '-tag red-',
        'pending': '-tag yellow-',
        'resolved': '-tag green-',
        'done': '-tag gray-'
      },
    }
  },
  methods: {
    ...mapActions('dashboard', ['selectServiceRequestStatus']),
    ...mapActions('servicerequest', ['getServiceRequestStatusCombo']),
    goServiceRequest(id){
      if(!!id){
        if(this.userInfo.auth === AUTH_GROUP.AccountManager){
          let a = document.createElement('a')
          a.target = "_blank"
          a.href = `https://support.bespinglobal.com/helpdesk/tickets/${id}`
          document.body.appendChild(a)
          a.onclick = function() {
            document.body.removeChild(a)
          }
          a.click()
        }else{
          this.$router.push(`/servicerequest/info?id=${id}`)
        }

      }
    },
    moreServiceRequest(){

      if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        let a = document.createElement('a')
        a.target = "_blank"
        a.href = `https://support.bespinglobal.com/support/tickets`
        document.body.appendChild(a)
        a.onclick = function() {
          document.body.removeChild(a)
        }
        a.click()
      }else{
        this.$router.push('/servicerequest/list?date=' +moment(new Date()).format("YYYY-MM-DD"))
      }
    }
  },
  mounted() {
    if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      let param = {}
      let today = moment(new Date()).format("YYYY-MM-DD")
      param.startDate = today
      param.endDate = today
      param.empNo = ""
      param.customerDepts = [{ customerCode : this.userInfo.customerCode, deptCode : this.userInfo.customerDeptCode, checked : true }]
      this.selectServiceRequestStatus(param)
    }
    this.getServiceRequestStatusCombo()
  },


}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/ServiceRequestStatus.vue